<template>
  <div class="px-2">
    <loading v-if="loading" loading-text="Carregando"></loading>
    <template v-else>
      <header>
        <div class="container">
          <div class="row row-wrap align-items-center">
            <h1 class="col-sm text-center text-sm-left">
              <img src="@/assets/images/logo-heppi.png" srcset="@/assets/images/logo-heppi@2x.png 2x">
              <small>Fatura Heppi</small>
            </h1>
            <div class="col-sm text-center text-sm-right text-secondary">
              <h2 style="margin-bottom: 10px;">Minhas Faturas</h2>
              <router-link :to="{ name: 'home' }">Fechar</router-link>
            </div>
          </div>
        </div>
      </header>
      <div class="container">
        <div class="row" style="max-width: 500px; margin: 0 auto">
          <div class="col tab" :class="{ 'active': tab === 'fundraising' }" @click="changeTab('fundraising')">Arrecadação</div>
          <div class="col tab" :class="{ 'active': tab === 'experience' }" @click="changeTab('experience')">Experiência</div>
        </div>
        <ul class="list-content" style="max-width: 500px; margin: 0 auto">
          <li class="list-item" v-for="(item, index) in invoices" :key="'item-' + index">
            <div class="list-item-content">
              <div class="list-item-subtitle">{{ item.date.toUpperCase() }} <span class="badge badge-small" :class="'badge-' + statusColor(item.status)">{{ item.status | statusDescription }}</span></div>
              <div class="list-item-text" style="padding-top: 5px">{{ item.description }}</div>
            </div>
            <div class="list-item-value" style="width: 24px">
              <router-link v-if="item.status === 'paid'" style="display: block; margin: -5px 0" :to="{ name: 'receipt', params: { id: item.id } }" target="_blank">
                <img src="@/assets/images/receipt.png" srcset="@/assets/images/receipt@2x.png 2x">
              </router-link>
              <router-link v-else style="display: block; margin: -5px 0" :to="{ name: 'invoice', params: { id: item.id } }" target="_blank">
                <img style="height: 28px" src="@/assets/images/barcode-details.png" srcset="@/assets/images/barcode-details@2x.png 2x">
              </router-link>
            </div>
          </li>
          <li class="list-item" v-if="loadingMore" :key="'item-loading'">
            <div class="list-item-content text-center">
              <img src="../assets/images/loading.svg" style="height: 30px" />
            </div>
          </li>
          <li class="list-item" v-else-if="invoices.length === 0" :key="'item-none'">
            <div class="list-item-content text-center">
              <div class="list-item-text py-1">Nenhuma fatura encontrada</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="pagination text-center">
        <button class="button button-icon button-secondary" :disabled="loadingMore || !(page > 1)" @click="goTo(-1)">&lsaquo;</button>
        {{ page }}/{{ last_page }}
        <button class="button button-icon button-secondary" :disabled="loadingMore || !(page < last_page)" @click="goTo(1)">&rsaquo;</button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'
import Loading from '@/components/Loading'

export default {
  name: 'home',
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      loadingMore: false,
      tab: 'fundraising',
      invoices: [],
      page: 1,
      last_page: 1
    }
  },
  filters: {
    statusDescription (val) {
      if (val === 'paid') return 'Pago'
      if (val === 'canceled') return 'Cancelado'
      if (val === 'undefined') return 'Problema na fatura'
      if (val === 'processing') return 'Em processamento'
      if (val === 'late') return 'Atrasado'
      else return 'Em aberto'
    },
    productDescription (val) {
      if (val === 'fundraising') return 'Arrecadação'
      if (val === 'experience') return 'Esperiência'
      else return val
    }
  },
  methods: {
    ...mapMutations(['SET_ERROR_PAGE']),
    statusColor (status) {
      if (status === 'paid') return 'success'
      if (status === 'canceled' || status === 'undefined') return 'mute'
      if (status === 'processing') return 'warning'
      if (status === 'late') return 'danger'
      else return 'secondary'
    },
    changeTab (tab) {
      if (!this.loadingMore && tab !== this.tab) {
        this.tab = tab
        this.invoices = []
        this.page = 1
        this.last_page = 1
        this.searchInvoices()
      }
    },
    goTo (value) {
      let newPage = this.page + value
      if (newPage > 0 && newPage <= this.last_page) {
        this.page = newPage
        this.invoices = []
        this.searchInvoices()
      }
    },
    searchInvoices () {
      let info = localStorage.getItem('at3')
      if (info) {
        info = JSON.parse(atob(info))
        if (this.$moment().isBefore(this.$moment(info.expires))) {
          let vue = this
          vue.loadingMore = true

          axios.get('invoices/customers/' + info.document + '?page=' + vue.page + '&product_reference=' + vue.tab)
            .then((response) => {
              if (response.data && response.data.data) {
                vue.invoices = response.data.data.map(e => {
                  return {
                    date: vue.$moment(e.invoice_date).format('MMMM YYYY'),
                    status: e.invoice_status,
                    product: e.product_reference,
                    description: e.description,
                    id: e.id
                  }
                })

                vue.last_page = response.data.meta.last_page
              } else {
                vue.SET_ERROR_PAGE('Error500')
              }
              vue.loading = false
              vue.loadingMore = false
            })
            .catch((error) => {
              if (error.response && error.response.status === '404') {
                vue.SET_ERROR_PAGE('Error404')
              } else {
                vue.SET_ERROR_PAGE('Error500')
              }
              vue.loading = false
              vue.loadingMore = false
            })
        } else {
          this.$router.push({ name: 'home' })
        }
      } else {
        this.$router.push({ name: 'home' })
      }
    }
  },
  mounted () {
    this.loading = true
    this.searchInvoices()
  }
}
</script>
